import GetLoading from "../../share/getLoading";
// import { useEffect, useState } from "react";
// import Table from "react-bootstrap/Table";
// import { request } from "../../share/request";
// import { Stack } from "react-bootstrap";
// import {
//   PlusCircleOutlined,
//   CheckCircleOutlined,
//   ClockCircleOutlined,
//   EditFilled,
//   DeleteFilled,
//   DoubleRightOutlined,
//   DoubleLeftOutlined,
//   RightOutlined,
//   LeftOutlined,
//   SaveOutlined,
//   SearchOutlined,
// } from "@ant-design/icons";
// import {
//   Modal,
//   Button,
//   Form,
//   Input,
//   Select,
//   Space,
//   Tag,
//   Checkbox,
//   Pagination,
//   InputNumber,
//   Tabs,
//   message,
//   Row,
//   Col,
// } from "antd";
// import "../../styles/Home-module.css";
// import { openNotification } from "../../share/message";

// import { getCurrentUser, getPermission } from "../../share/getProfile";
// import { getTageStyle } from "../../share/getStatusContent";
// import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";
// import DeleteDepartmentModal from "../../component/DeleteModal/DeleteDepartmentModal";

// const { Option } = Select;

// // Font styles
// const khmerFont = {
//   fontFamily: "'Content', system-ui, sans-serif",
// };

// const englishFont = {
//   fontFamily: "'Poppins-SemiBold', 'Poppins', 'Poppins SemiBold', system-ui, sans-serif",
// };

// const mixedFont = {
//   fontFamily: "'Poppins-SemiBold', 'Content', system-ui, sans-serif",
// };

// // ════════════════════════════════════════════════════════════════════
// //  TAB 1 — Department Management (original page)
// // ════════════════════════════════════════════════════════════════════
// const DepartmentTab = () => {
//   const getProfileOrg = getCurrentUser();
//   const [Total, setTotalCount] = useState(0);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [list, setList] = useState([]);
//   const [listdepart, setListDepart] = useState([]);
//   const [visableNewDepartment, setVisableNewDepartment] = useState(false);
//   const [visableDeleteModel, setVisableDeleteModel] = useState(false);
//   const [visableTextbox, setVisableTextbox] = useState(false);
//   const [code, setCode] = useState("");
//   const [department, setDepartment] = useState("");
//   const [department_en, setDepartment_EN] = useState("");
//   const [des, setDes] = useState("");
//   const [other, setOther] = useState("");
//   const [level_number, setLevel_number] = useState("");
//   const [under_dept_id, setUnderDepartment_id] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [loadingSpin, setLoadingSpin] = useState(false);
//   const [enable, setEnable] = useState(false);
//   const [disable, setDisable] = useState(true);
//   const [pageNumber, setPageNumber] = useState(1);

//   const [objFilter, setObjFilter] = useState({
//     page: 1,
//     department_name: "",
//     org_code: getProfileOrg?.org_code || 1,
//   });

//   // permissions
//   const userPermission = getPermission();
//   const deapartmentValue = userPermission.find(
//     (permission) => permission.pagename === "department"
//   ) || { add: 0, edit: 0, deleted: 0 };
//   const { add: addvalue, edit: Editvalue, deleted: deletevalue } = deapartmentValue;

//   // initial load
//   useEffect(() => {
//     getList(objFilter);
// getListAllDepartments(objFilter);
//   }, []);

//   const getList = async (filter) => {
//     const param = new URLSearchParams({
//       page: filter.page || 1,
//       department_name: filter.department_name || "",
//       org_code: filter.org_code || 1,
//     });
//     try {
//       await new Promise((resolve) => setTimeout(resolve, 400));
//       const res = await request("department?" + param.toString(), "get", {});
//       if (res) {
//         setList(res.listdepartment || []);
       
//         setTotalCount(res.total_records || 0);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const getListAllDepartments = async (filter) => {
//     const param = new URLSearchParams({
     
//       department_name: filter.department_name || "",
//       org_code: filter.org_code || 1,
//     });
//     try {
//       await new Promise((resolve) => setTimeout(resolve, 400));
//       const res = await request("departmentall?" + param.toString(), "get", {});
//       if (res) {
      
//         setListDepart(res.listdepartment || []);
       
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const getListDept = async (filter) => {
//     const param = new URLSearchParams({
//       page: filter.page || 1,
//       department_name: filter.department_name || "",
//       org_code: filter.org_code || 1,
//     });
//     try {
//       const res = await request("department?" + param.toString(), "get", {});
//       if (res) {
//         setListDepart(res.listdepartment || []);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   // pagination
//   const itemsPerPage = 10;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = list.slice(indexOfFirstItem, indexOfLastItem);

//   const buttonStyle = { fontFamily: "'Content', sans-serif" };
//   const custom_model = { fontFamily: "'Content', sans-serif" };

//   const onOpenNewDepartment = () => {
//     setVisableTextbox(true);
//     setVisableNewDepartment(true);
//     setCode("");
//     setDepartment("");
//     setDepartment_EN("");
//     setDes("");
//     setOther("");
//     setLevel_number("");
//     setUnderDepartment_id("");
//     setEnable(false);
//     setDisable(true);
//   };
//  // Add state at the top of DepartmentTab component
// const [deleteModalVisible, setDeleteModalVisible] = useState(false);
// const [deleteDepartmentData, setDeleteDepartmentData] = useState({
//   departmentName: "",
//   departmentCode: "",
//   departmentId: "",
//   parentDept: "",
// });

// // Update onOpenModelDelete function
// const onOpenModelDelete = (item) => {
//   setDeleteDepartmentData({
//     departmentName: item.department_name,
//     departmentCode: item.code,
//     departmentId: item.id || item.code,
//     parentDept: item.parent_dept || "",
//   });
//   console.log("Prepared delete data:", {
//     departmentName: item.department_name,
//     departmentCode: item.code,
//     departmentId: item.id || item.code,
//     parentDept: item.parent_dept || "",
//   });
//   setDeleteModalVisible(true);
// };

// // Update onClickDeleteYes function - FIXED
// const onClickDeleteYes = async () => {
//   const { departmentCode } = deleteDepartmentData;  // Correct destructuring
//   console.log("Deleting department with code:", departmentCode);
  
//   if (!departmentCode) {
//     message.error("Department code not found");
//     return;
//   }
  
//   try {
//     const res = await request("department/" + departmentCode, "delete", {});
//     if (res.success===true) {
//       getList(objFilter);
//       openNotification("success", "Success", "Department deleted successfully");
//       setDeleteModalVisible(false);
//     } else {
//       message.error(res?.message || "Error deleting department");
//     }
//   } catch (error) {
//     console.error("Delete error:", error);
//     message.error("Failed to delete department");
//   }
// };

 
 
//   const onCloseDepartment = () => setVisableNewDepartment(false);
//   const onCancel = () => setVisableNewDepartment(false);
//   const onCancelDelete = () => setVisableDeleteModel(false);
//   const onclickDeleteNo = () => setVisableDeleteModel(false);

//   const onChangeCode = (e) => setCode(e.target.value);
//   const onChangeDeparment = (e) => setDepartment(e.target.value);
//   const onChangeDeparment_en = (e) => setDepartment_EN(e.target.value);
//   const onChageDes = (e) => setDes(e.target.value);
//   const onChangeOther = (e) => setOther(e.target.value);
//   const onChangeLevel_number = (e) => setLevel_number(e);

//   const handleCheckboxChange_Enable = (e) => {
//     setEnable(e.target.checked);
//     setDisable(false);
//   };
//   const handleCheckboxChange_Diable = (e) => {
//     setDisable(e.target.checked);
//     setEnable(false);
//   };

//   const onSaveDepartment = async () => {
//     const data = {
//       code: code,
//       department_name: department,
//       department_en: department_en,
//       department_des: des,
//       other: other,
//       status: enable ? 1 : 0,
//       org_code: getProfileOrg?.org_code,
//       under_dept_id: under_dept_id,
//       level_number: level_number,
//     };

//     try {
//       const method = !code ? "post" : "put";
//       const res = await request("department", method, data);
//       setVisableNewDepartment(false);
//       if (res && res.success) {
//         getList(objFilter);
//         openNotification("success", "Success", res.message || (method === "post" ? "Created" : "Updated"));
//       } else {
//         openNotification("error", "Error", res?.message || "Something went wrong");
//       }
//     } catch (error) {
//       openNotification("error", "Error", "Something went wrong");
//     }
//   };

//   const onOpenEditModel = (item) => {
//     setVisableTextbox(true);
//     setVisableNewDepartment(true);
//     setUnderDepartment_id(item.parent_id);
//     setLevel_number(item.level_no);
//     setCode(item.code);
//     setDepartment(item.department_name);
//     setDepartment_EN(item.department_en);
//     setDes(item.department_des);
//     setOther(item.other);
//     if (item.status === 1) {
//       setEnable(true);
//       setDisable(false);
//     } else {
//       setEnable(false);
//       setDisable(true);
//     }
//   };

 

//   const getStatusContent = (status) => {
//     switch (status) {
//       case 1:
//         return (
//           <Button type="primary" ghost shape="round" icon={<CheckCircleOutlined />} style={mixedFont}>
//             Enable
//           </Button>
//         );
//       case 0:
//         return (
//           <Button type="primary" danger ghost shape="round" icon={<ClockCircleOutlined />} style={mixedFont}>
//             Disable
//           </Button>
//         );
//       default:
//         return null;
//     }
//   };

//   const onShowSizeChange = async (current) => {
//     setPageNumber(current);
//     const objTmp = { ...objFilter, page: current };
//     setObjFilter(objTmp);
//     await getList(objTmp);
//   };

//   const OnSearchText = (value) => {
//     setCurrentPage(1);
//     const objTmp = {
//       ...objFilter,
//       department_name: value.target.value,
//       page: 1,
//     };
//     setObjFilter(objTmp);
//     getList(objTmp);
//   };

//   const OnSearchTextDept = (value) => {
//     const objTmp = {
//       ...objFilter,
//       department_name: value.target.value,
//       page: 1,
//     };
//     getListDept(objTmp);
//   };

//   return (
//     <div style={khmerFont}>
//       <div className="sprinSave-container">
//         {loadingSpin && (
//           <div className="sprinSave">
//             <GetLoading />
//           </div>
//         )}
//       </div>

//       <div style={boxHeader}>
//         <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
//           {boxHeaderTagText("ការគ្រប់គ្រង់ ព័ត៌មានផ្នែក")}
//           <Input style={{ width: 250, ...mixedFont }} placeholder="ស្វែងរក..." onChange={OnSearchText} allowClear />
//         </div>
//         <div>
//           <Button disabled={!addvalue} onClick={onOpenNewDepartment} type="primary" icon={<PlusCircleOutlined />} style={mixedFont}>
//             បន្ថែមផ្នែកថ្មី
//           </Button>
//         </div>
//       </div>

//       <div>
//         {loading ? (
//           <div className="sprinCustome">
//             <GetLoading />
//           </div>
//         ) : (
//           <Table className="rounded-table">
//             <thead>
//               <tr className="table-success">
//                 <th style={khmerFont}>#</th>
//                 <th style={khmerFont}>លេខកូដ</th>
//                 <th style={khmerFont}>ផ្នែក (ខ្មែរ)</th>
//                 <th style={englishFont}>Department (English)</th>
//                 <th style={khmerFont}>ស្ថិតក្រោម</th>
//                 <th style={khmerFont}>កំរិត</th>
//                 <th style={mixedFont}>ស្ថានភាព / Status</th>
//                 <th style={khmerFont}>សកម្មភាព</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentData.map((item, idx) => (
//                 <tr key={item.code || idx}>
//                   <td style={khmerFont}>{itemsPerPage * (pageNumber - 1) + idx + 1}</td>
//                   <td style={khmerFont}>{getTageStyle("CODE:" + item.code)}</td>
//                   <td style={khmerFont}><strong>{item.department_name}</strong></td>
//                   <td style={englishFont}>{item.department_en}</td>
//                   <td style={khmerFont}>{item.parent_dept && <Tag color="magenta" style={khmerFont}>{item.parent_dept}</Tag>}</td>
//                   <td style={khmerFont}>{item.level_no}</td>
//                   <td style={mixedFont}>{getStatusContent(item.status)}</td>
//                   <td style={{ width: 100 }}>
//                     <Stack gap={1} direction="horizontal">
//                       <Button type="primary" icon={<EditFilled />} disabled={!Editvalue} onClick={() => onOpenEditModel(item)} />
//                       <Button icon={<DeleteFilled />} disabled={!deletevalue} onClick={() => onOpenModelDelete(item)} danger />
//                     </Stack>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         )}
//         <Pagination onChange={onShowSizeChange} defaultCurrent={currentPage} total={Total} style={{ marginTop: 16, textAlign: "center" }} />
//       </div>

//       {/* Add/Edit Modal */}
//       <Modal
//         title={!code ? "បង្កើតផ្នែកថ្មី" : "កែប្រែផ្នែក"}
//         width={700}
//         open={visableNewDepartment}
//         onCancel={onCancel}
//         footer={[
//           <Button key="cancel" danger onClick={onCloseDepartment} style={mixedFont}>Cancel</Button>,
//           <Button key="save" type="primary" onClick={onSaveDepartment} style={mixedFont}>{!code ? "Save" : "Update"}</Button>,
//         ]}
//       >
//         <Row gutter={16}>
//           <Col span={12}>
//             <Form.Item label={<span style={khmerFont}>លេខកូដផ្នែក</span>}>
//               <Input value={code} onChange={onChangeCode} disabled={visableTextbox} style={khmerFont} />
//             </Form.Item>
//             <Form.Item label={<span style={khmerFont}>ឈ្មោះផ្នែក / ភាសាខ្មែរ</span>}>
//               <Input.TextArea rows={2} value={department} onChange={onChangeDeparment} style={khmerFont} />
//             </Form.Item>
//             <Form.Item label={<span style={englishFont}>Department Name / English</span>}>
//               <Input.TextArea rows={2} value={department_en} onChange={onChangeDeparment_en} style={englishFont} />
//             </Form.Item>
//             <Form.Item label={<span style={mixedFont}>ស្ថានភាព / Status</span>}>
//               <Space>
//                 <Checkbox checked={enable} onChange={handleCheckboxChange_Enable} style={mixedFont}>Enable</Checkbox>
//                 <Checkbox checked={disable} onChange={handleCheckboxChange_Diable} style={mixedFont}>Disable</Checkbox>
//               </Space>
//             </Form.Item>
//           </Col>
//           <Col span={12}>
//             <Form.Item label={<span style={khmerFont}>ស្ថិតក្រោម</span>}>
//               <Select
//                 showSearch allowClear placeholder="Select department"
//                 value={under_dept_id}
//                 onSearch={(val) => OnSearchTextDept({ target: { value: val } })}
//                 onChange={setUnderDepartment_id}
//                 style={khmerFont}
//               >
//                 {listdepart.map(opt => (
//                   <Option key={opt.code} value={opt.code} style={khmerFont}>{opt.department_name}</Option>
//                 ))}
//               </Select>
//             </Form.Item>
//             <Form.Item label={<span style={khmerFont}>កំរិត</span>}>
//               <InputNumber min={1} max={10} value={level_number} onChange={onChangeLevel_number} style={{ width: "100%" }} />
//             </Form.Item>
//             <Form.Item label={<span style={khmerFont}>បរិយាយ</span>}>
//               <Input.TextArea rows={3} value={des} onChange={onChageDes} style={khmerFont} />
//             </Form.Item>
//             <Form.Item label={<span style={khmerFont}>ផ្សេងៗ</span>}>
//               <Input.TextArea rows={2} value={other} onChange={onChangeOther} style={khmerFont} />
//             </Form.Item>
//           </Col>
//         </Row>
//       </Modal>

   
// <DeleteDepartmentModal
//   visible={deleteModalVisible}
//   onCancel={() => setDeleteModalVisible(false)}
//   onConfirm={onClickDeleteYes}
//   departmentName={deleteDepartmentData.departmentName}
//   departmentCode={deleteDepartmentData.departmentCode}
//   departmentId={deleteDepartmentData.departmentId}
//   parentDept={deleteDepartmentData.parentDept}
//   loading={loadingSpin}
// />
//     </div>
//   );
// };

// // ════════════════════════════════════════════════════════════════════
// //  TAB 2 — Short Department (transfer / ordering UI)
// // ════════════════════════════════════════════════════════════════════
// const ShortDepartmentTab = ({ org_code }) => {
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [leftItems, setLeftItems] = useState([]);
//   const [rightItems, setRightItems] = useState([]);
//   const [leftSelected, setLeftSelected] = useState([]);
//   const [rightSelected, setRightSelected] = useState([]);
//   const [leftSearch, setLeftSearch] = useState("");
//   const [rightSearch, setRightSearch] = useState("");

//   // fetch all departments
//   useEffect(() => {
//     const fetchDepts = async () => {
//       setLoading(true);
//       try {
//         const param = new URLSearchParams({
//           org_code: org_code,
//         });
//         const res = await request("departmentall?" + param.toString(), "get", {});
        
//         if (res && res.listdepartment && Array.isArray(res.listdepartment)) {
//           const mapped = res.listdepartment.map((d, idx) => ({
//             ...d,
//             _uid: d.code || d.id || idx,
//           }));
          
//           // Split: assigned (have range_id) vs unassigned
//           const assigned = mapped.filter(d => d.range_id && d.range_id !== null && d.range_id !== undefined);
//           const unassigned = mapped.filter(d => !d.range_id || d.range_id === null || d.range_id === undefined);
          
//           assigned.sort((a, b) => (a.range_id || 999) - (b.range_id || 999));
          
//           setLeftItems(unassigned);
//           setRightItems(assigned);
//         } else {
//           setLeftItems([]);
//           setRightItems([]);
//         }
//       } catch (e) {
//         console.error("Error fetching departments:", e);
//         message.error("Failed to load departments");
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     if (org_code) {
//       fetchDepts();
//     }
//   }, [org_code]);

//   const toggleLeft = (uid) =>
//     setLeftSelected((prev) => (prev.includes(uid) ? prev.filter((x) => x !== uid) : [...prev, uid]));

//   const toggleRight = (uid) =>
//     setRightSelected((prev) => (prev.includes(uid) ? prev.filter((x) => x !== uid) : [...prev, uid]));

//   const moveSelectedRight = () => {
//     const moving = leftItems.filter((d) => leftSelected.includes(d._uid));
//     setRightItems((prev) => [...prev, ...moving]);
//     setLeftItems((prev) => prev.filter((d) => !leftSelected.includes(d._uid)));
//     setLeftSelected([]);
//   };

//   const moveSelectedLeft = () => {
//     const moving = rightItems.filter((d) => rightSelected.includes(d._uid));
//     setLeftItems((prev) => [...prev, ...moving]);
//     setRightItems((prev) => prev.filter((d) => !rightSelected.includes(d._uid)));
//     setRightSelected([]);
//   };

//   const moveAllRight = () => {
//     setRightItems((prev) => [...prev, ...leftItems]);
//     setLeftItems([]);
//     setLeftSelected([]);
//   };

//   const moveAllLeft = () => {
//     setLeftItems((prev) => [...prev, ...rightItems]);
//     setRightItems([]);
//     setRightSelected([]);
//   };

//   const handleSave = async () => {
//     if (rightItems.length === 0) {
//       message.warning("សូមជ្រើសរើសផ្នែកយ៉ាងហោចណាស់មួយ");
//       return;
//     }

//     const payload = {
//       org_code: org_code,
//       department: rightItems.map((d, idx) => ({
//         code: d.code,
//         range_id: idx + 1,
//       })),
//     };

//     console.log("Save payload:", JSON.stringify(payload, null, 2));
//     setSaving(true);

//     try {
//       const res = await request("department/short", "post", payload);
//       if (res && res.success) {
//         message.success(res.message || "រក្សាទុកបានជោគជ័យ");
        
//         // Refresh data
//         const param = new URLSearchParams({ org_code: org_code });
//         const refreshRes = await request("department?" + param.toString(), "get", {});
//         if (refreshRes && refreshRes.listdepartment) {
//           const mapped = refreshRes.listdepartment.map((d, idx) => ({
//             ...d,
//             _uid: d.code || d.id || idx,
//           }));
//           const assigned = mapped.filter(d => d.range_id && d.range_id !== null);
//           const unassigned = mapped.filter(d => !d.range_id || d.range_id === null);
//           assigned.sort((a, b) => (a.range_id || 999) - (b.range_id || 999));
//           setLeftItems(unassigned);
//           setRightItems(assigned);
//         }
//       } else {
//         message.error(res?.message || "Something went wrong");
//       }
//     } catch (e) {
//       console.error("Save error:", e);
//       message.error("Something went wrong");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const filteredLeft = leftItems.filter(
//     (d) =>
//       (d.department_name || "").toLowerCase().includes(leftSearch.toLowerCase()) ||
//       (d.department_en || "").toLowerCase().includes(leftSearch.toLowerCase()) ||
//       String(d.code || "").toLowerCase().includes(leftSearch.toLowerCase())
//   );

//   const filteredRight = rightItems.filter(
//     (d) =>
//       (d.department_name || "").toLowerCase().includes(rightSearch.toLowerCase()) ||
//       (d.department_en || "").toLowerCase().includes(rightSearch.toLowerCase()) ||
//       String(d.code || "").toLowerCase().includes(rightSearch.toLowerCase())
//   );

//   const renderColumn = (items, allItems, selected, onToggle, search, onSearch, title) => (
//     <div style={{ ...styles.column, ...khmerFont }}>
//       <div style={styles.columnHeader}>
//         <span style={khmerFont}>{title}</span>
//         <Tag style={styles.columnBadge}>{allItems.length}</Tag>
//       </div>
//       <div style={styles.searchBar}>
//         <Input
//           size="small"
//           prefix={<SearchOutlined style={{ color: "#bbb" }} />}
//           placeholder="ស្វែងរក / Search..."
//           value={search}
//           onChange={(e) => onSearch(e.target.value)}
//           allowClear
//           style={mixedFont}
//         />
//       </div>
//       <div style={styles.columnList}>
//         {items.length === 0 ? (
//           <div style={styles.emptyState}>គ្មានទិន្នន័យ</div>
//         ) : (
//           <div>
//             {items.map((item, idx) => {
//               const isSelected = selected.includes(item._uid);
//               return (
//                 <div
//                   key={item._uid}
//                   onClick={() => onToggle(item._uid)}
//                   style={{
//                     ...styles.listItem,
//                     background: isSelected ? "#e6f7ff" : "#fafafa",
//                     borderLeft: isSelected ? "3px solid #1677ff" : "3px solid transparent",
//                   }}
//                 >
//                   <div style={{ width: 30, ...khmerFont }}>{idx + 1}</div>
//                   <div style={{ width: 80 }}>
//                     <Tag color="blue" style={{ fontSize: 11, ...khmerFont }}>{item.code}</Tag>
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div style={{ fontWeight: isSelected ? 600 : 400, ...khmerFont }}>{item.department_name}</div>
//                     {item.department_en && <div style={{ color: "#999", fontSize: 11, ...englishFont }}>{item.department_en}</div>}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   if (loading) {
//     return (
//       <div style={{ textAlign: "center", padding: 60 }}>
//         <GetLoading />
//       </div>
//     );
//   }

//   return (
//     <div style={{ padding: "12px 0", ...khmerFont }}>
//       <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 14 }}>
//         <Button type="primary" icon={<SaveOutlined />} loading={saving} onClick={handleSave} style={mixedFont}>
//           រក្សាទុក / Save
//         </Button>
//       </div>

//       <div style={{ display: "flex", gap: 10 }}>
//         {/* LEFT COLUMN - All Departments */}
//         {renderColumn(filteredLeft, leftItems, leftSelected, toggleLeft, leftSearch, setLeftSearch, "ផ្នែកទាំងអស់")}

//         {/* CENTER COLUMN - Action Buttons */}
//         <div style={styles.buttonColumn}>
//           <Button size="small" icon={<DoubleRightOutlined />} onClick={moveAllRight} disabled={leftItems.length === 0} title="Move all" />
//           <Button size="small" icon={<RightOutlined />} onClick={moveSelectedRight} disabled={leftSelected.length === 0} title="Move selected" />
//           <Button size="small" icon={<LeftOutlined />} onClick={moveSelectedLeft} disabled={rightSelected.length === 0} title="Move back" />
//           <Button size="small" icon={<DoubleLeftOutlined />} onClick={moveAllLeft} disabled={rightItems.length === 0} title="Move all back" />
//         </div>

//         {/* RIGHT COLUMN - Selected Departments */}
//         {renderColumn(filteredRight, rightItems, rightSelected, toggleRight, rightSearch, setRightSearch, "ផ្នែកដែលបានជ្រើសរើស")}
//       </div>

//       {/* Payload Preview */}
//       {/* {rightItems.length > 0 && (
//         <div style={styles.payloadPreview}>
//           <strong>Payload preview:</strong>{" "}
//           {JSON.stringify({
//             org_code: org_code,
//             department: rightItems.map((d, i) => ({ code: d.code, range_id: i + 1 })),
//           })}
//         </div>
//       )} */}
//     </div>
//   );
// };

// // Styles
// const styles = {
//   column: {
//     flex: 1,
//     border: "1px solid #d9d9d9",
//     borderRadius: 8,
//     overflow: "hidden",
//     display: "flex",
//     flexDirection: "column",
//     background: "#fff",
//     boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
//   },
//   columnHeader: {
//     background: "linear-gradient(90deg, #1677ff 0%, #4096ff 100%)",
//     color: "#fff",
//     padding: "9px 14px",
//     fontWeight: 600,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//   },
//   columnBadge: {
//     background: "rgba(255,255,255,0.25)",
//     border: "none",
//     color: "#fff",
//     fontWeight: 700,
//   },
//   searchBar: {
//     padding: "8px 10px",
//     borderBottom: "1px solid #f0f0f0",
//   },
//   columnList: {
//     flex: 1,
//     overflowY: "auto",
//     maxHeight: 600,
//   },
//   listItem: {
//     padding: "10px 12px",
//     marginBottom: 4,
//     cursor: "pointer",
//     transition: "all 0.15s",
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     borderBottom: "1px solid #f5f5f5",
//   },
//   emptyState: {
//     padding: 32,
//     textAlign: "center",
//     color: "#bbb",
//   },
//   buttonColumn: {
//     display: "flex",
//     flexDirection: "column",
//     gap: 10,
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//     padding: "0 4px",
//   },
//   payloadPreview: {
//     marginTop: 14,
//     padding: "10px 14px",
//     background: "#f6ffed",
//     border: "1px solid #b7eb8f",
//     borderRadius: 8,
//     fontSize: 11,
//     fontFamily: "monospace",
//     color: "#389e0d",
//     wordBreak: "break-all",
//   },
// };

// // ════════════════════════════════════════════════════════════════════
// //  ROOT — Main Component with Tabs
// // ════════════════════════════════════════════════════════════════════
// const DepartmentPage = () => {
//   const getProfileOrg = getCurrentUser();

//   const khmerFontStyle = {
//     fontFamily: "'Content', system-ui, sans-serif",
//   };

//   const tabItems = [
//     {
//       key: "department",
//       label: <span style={khmerFontStyle}>ការគ្រប់គ្រង់ផ្នែក</span>,
//       children: <DepartmentTab />,
//     },
//     {
//       key: "short_department",
//       label: <span style={khmerFontStyle}>តម្រៀបផ្នែក</span>,
//       children: <ShortDepartmentTab org_code={getProfileOrg?.org_code} />,
//     },
//   ];

//   return <Tabs defaultActiveKey="department" items={tabItems} type="card" />;
// };

// export default DepartmentPage;



// DepartmentPage.js
import { Tabs } from "antd";
import { getCurrentUser } from "../../share/getProfile";
import InformationDeptPage from "./InformationDeptPage";
import ShortDeptPage from "./ShortDeptPage";
import OrganisationChart from "./OrganisationChart";

// Font styles
const khmerFontStyle = {
  fontFamily: "'Content', system-ui, sans-serif",
};

const DepartmentPage = () => {
  const getProfileOrg = getCurrentUser();

  const tabItems = [
    {
      key: "information",
      label: <span style={khmerFontStyle}>ការគ្រប់គ្រង់ផ្នែក</span>,
      children: <InformationDeptPage />,
    },
    // {
    //   key: "short_department",
    //   label: <span style={khmerFontStyle}>តម្រៀបផ្នែក</span>,
    //   children: <ShortDeptPage org_code={getProfileOrg?.org_code} />,
    // },  
    {
    key: "organisation_chart",
    label: <span style={khmerFontStyle}>រចនាសម្ព័ន្ធអង្គភាព</span>,
    children: <OrganisationChart org_code={getProfileOrg?.org_code} />,
  },
  ];

  return <Tabs defaultActiveKey="information" items={tabItems} type="card" />;
};

export default DepartmentPage;